import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { sheet } from "@/interface/dataInterface";
import { FC } from "react";
import CommonDetailsRightSheet from "@/components/common/details/DetailsRightSheet";
import { TaxiClient } from "@/interface/entityInterface";
import { UserIcon, PhoneIcon, MailIcon } from "lucide-react";
import CallsTimeline from "./Calls";
import { useNavigate } from "react-router-dom";

interface Props extends sheet {
  client: TaxiClient | null;
}

interface CardProps {
  customIcon: any;
  title: string;
  label: string;
}

const DetailCard: FC<CardProps> = ({ customIcon: Icon, title, label }) => (
  <div className="w-full h-32 bg-muted rounded-xl p-4 text-center">
    <Icon className="w-8 h-8 mx-auto text-muted-foreground mb-2" />
    <p className="text-[15px] text-muted-foreground mb-1">{title}</p>
    <p className="text-[20px] font-medium">{label || "--"}</p>
  </div>
);

const ClientsDetails: FC<Props> = ({ open, setOpen, client }) => {
  const navigate = useNavigate();

  if (!client) return;

  return (
    <CommonDetailsRightSheet
      open={open}
      setOpen={setOpen}
      title="Client details"
    >
      <div className="grid place-items-center px-3 sm:px-10">
        <div className="w-full">
          <div className="grid sm:grid-cols-2 place-items-center gap-4">
            <DetailCard
              customIcon={UserIcon}
              title="Full Name"
              label={client.name}
            />
            <DetailCard
              customIcon={PhoneIcon}
              title="Phone"
              label={client.phone_number}
            />
            <DetailCard
              customIcon={MailIcon}
              title="Home address"
              label={client.home_address}
            />
          </div>
        </div>
        <div className="w-full mx-auto mt-3">
          <Tabs defaultValue="calls" className="w-full">
            <ScrollArea className="w-full mx-auto">
              <TabsList className="w-full mx-auto">
                <TabsTrigger value="calls" className="text-md sm:text-xl">
                  Call log
                </TabsTrigger>
                <TabsTrigger
                  value="orders"
                  className="text-md sm:text-xl"
                  onClick={() => {
                    navigate("/taxi-orders", {
                      state: { client_phone: client.phone_number },
                    });
                  }}
                >
                  Orders
                </TabsTrigger>
              </TabsList>
              <ScrollBar orientation="horizontal" />
            </ScrollArea>
            <TabsContent value="calls">
              <CallsTimeline phoneNumber={client.phone_number} />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </CommonDetailsRightSheet>
  );
};

export default ClientsDetails;
